var map = {
	"./gxp_geo.json": [
		640,
		0
	],
	"./gz_geo.json": [
		969,
		5
	],
	"./island_geo.json": [
		970,
		6
	],
	"./line_co_geo.json": [
		971,
		7
	],
	"./nrr_geo.json": [
		972,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 950;
module.exports = webpackAsyncContext;